<template>
  <form-builder :fields="fields" @data="$emit('data', $event)"></form-builder>
</template>

<script>
import FormBuilder from '../FormBuilder.vue'

export default {
  components: {
    FormBuilder
  },
  data () {
    return {
      fields: [
        {
          name: 'name',
          label: 'Name',
          type: 'text',
          required: true
        },
        {
          name: 'email',
          label: 'Email',
          type: 'email',
          required: true
        }
      ]
    }
  }
}
</script>
